import { collection, getDocs, orderBy, query, where } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from '../Admin/Config/Config';

export default function ClipPayment({toogle,onResult, onClose}) {
      const [isModalOpen, setIsModalOpen] = useState(false);
      useState(() => {
          setIsModalOpen(toogle);
      },[toogle]);
      // ================== FETCH PAYMENT DETAILS ================== //
      const [planList, setPlanList] = useState([]);
      const handleFetch = async () => {
          const ref = collection(db, "bristu_clipchat_plans");
          const q = query(ref, where("status", "==", true), orderBy("order", "asc"));
          const querySnapshot = await getDocs(q);
          const data = [];
          querySnapshot.forEach((doc) => {
            data.push({ id: doc.id, ...doc.data() });
          });
          setPlanList(data);
      }
      useEffect(() => {
          handleFetch();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      },[]);

  return (
    <div>
      {" "}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl p-4 max-w-xl w-full mx-4 shadow-xl border border-gray-100">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl px-2 font-medium text-gray-900">
                Select Your Plan
              </h3>
              <button
                onClick={() => {
                  onClose();
                  setIsModalOpen(false);
                }}
                className="p-2 hover:bg-gray-50 rounded-full transition-colors"
              >
                <svg
                  className="w-6 h-6 text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {planList &&
              planList.map((item) => (
                <div className="grid grid-cols-1 gap-6 ">
                  <div className="relative bg-gradient-to-br from-white to-gray-50 rounded-xl p-4 transition-all hover:shadow-lg border-2 border-gray-200/50 hover:border-emerald-600 group">
                    <div className="mb-4">
                      <h4 className="text-lg font-semibold text-gray-900 mb-1">
                        {item.title}
                      </h4>
                      <p className="text-gray-500 text-sm">
                        {item.desc}
                      </p>
                    </div>
                    <div className="mb-6">
                      <div className="flex items-baseline gap-2">
                        <span className="text-3xl font-bold text-gray-900">
                          ₹{item.offer_price}
                        </span>
                        <span className="text-red-500 line-through">₹ {item.price}</span>
                      </div>
                      <div className="text-sm text-emerald-600 font-medium mt-2">
                        Save ₹{item.price-item.offer_price}
                      </div>
                    </div>
                    <button onClick={()=>onResult(item.id)} className="w-full bg-gradient-to-r from-emerald-500 to-emerald-600 text-white py-3.5 rounded-xl font-medium hover:shadow-emerald/20 hover:shadow-lg transition-all">
                      Buy Now
                    </button>
                  </div>
                </div>
              ))}

            <p className="text-center text-sm text-gray-500 mt-4">
              All plans include premium features and 24/7 support
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
